<template>
  <b-modal
    id="asignarAvlsModal"
    size="xl"
    title="Agregar accesos AVL's a instalador"
    hide-footer
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <div class="card container-fluid">
      <div class="card-body">
        <div class="container-fluid h-100">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="quickFilter" class="label">Filtro rapido</label>
                <input
                  type="text"
                  id="quickFilter"
                  v-model="quickFilter"
                  class="form-control"
                />
              </div>
              <div class="row mb-2 ml-0">
                <div
                  class=""
                  v-for="item in seleccionados"
                  :key="`${item.id_avl}-${item.cliente}`"
                >
                  <span class="badge badge-custom">
                    {{ item.patente }}
                    <template
                      v-if="item.dominio && item.dominio !== item.patente"
                    >
                      - {{ item.dominio }}
                    </template>

                    <button
                      @click="quitarPatente(item)"
                      class="btn btn-xs btn-badge-close"
                      title="Quitar"
                    >
                      ×
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="height: 100%">
            <div class="col" style="position: relative; height: 100%">
              <ag-grid-vue
                style="width: 100%; height: 50vh"
                class="ag-theme-alpine"
                :columnDefs="columnDefs"
                :rowData="rowData"
                @grid-ready="onGridReady"
                @selection-changed="onSelectionChanged"
                :defaultColDef="defaultColDef"
                :rowSelection="'multiple'"
                :rowMultiSelectWithClick="true"
                :getContextMenuItems="getContextMenuItems"
                :gridOptions="gridOptions"
              >
              </ag-grid-vue>
            </div>
          </div>
        </div>

        <form
          v-promise-btn="{ action: 'submit' }"
          @submit.prevent="submit"
          v-if="this.idAvls"
        >
          <template>
            <div class="container pt-2">
              <div class="row">
                <div class="col-12 form-group form-group-sm">
                  <label class="label" for="instalador">Instalador</label>
                  <SelectInstalador v-model="instalador" />
                </div>
                <div
                  class="col-12 form-group form-group-sm d-flex justify-content-end"
                >
                  <button
                    type="button"
                    class="btn btn-secondary mr-2"
                    @click="cerrarModal"
                  >
                    Cancelar
                  </button>
                  <button type="submit" class="btn btn-primary">
                    Procesar
                  </button>
                </div>
              </div>
            </div>
          </template>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";
import { get } from "lodash-es";
import axios from "axios";
import SelectInstalador from "@/pages/Clientes/Contratos/Commons/SelectInstalador";

export default {
  name: "AsignarAvlsModal",
  components: { AgGridVue, SelectInstalador },
  methods: {
    onModalShown() {
      this.getContratos();
    },
    onModalHidden() {
      this.limpiarDatos();
    },
    cerrarModal() {
      this.$bvModal.hide("asignarAvlsModal");
    },
    limpiarDatos() {
      this.quickFilter = "";
      this.seleccionados = [];
      this.idAvls = "";
      this.instalador = null;
      this.rowData = null;
      if (this.gridApi) {
        this.gridApi.deselectAll();
      }
    },
    limpiarFiltro() {
      this.quickFilter = "";
    },
    quitarPatente(params) {
      this.seleccionados = this.seleccionados.filter(
        (item) =>
          `${item.id_avl}-${item.cliente}` !==
          `${params.id_avl}-${params.cliente}`,
      );
    },
    onSelectionChanged() {
      const selectNodes = this.gridApi.getSelectedNodes();
      this.limpiarFiltro();
      const selectAvls = selectNodes.map((node) => node.data.id_avl);
      this.seleccionados = selectNodes.map((node) => node.data);
      this.idAvls = selectAvls.toString();
    },
    actualizarSeleccionPatentes() {
      const selectNodes = this.gridApi.getSelectedNodes();
      selectNodes.forEach((node) => {
        if (
          !this.seleccionados.find(
            (item) =>
              `${item.id_avl}-${item.cliente}` ===
              `${node.data.id_avl}-${node.data.cliente}`,
          )
        ) {
          this.gridApi.deselectNode(node);
        }
      });
    },
    async submit() {
      if (!this.instalador) {
        this.$msgBoxOk("Elija un instalador");
        return;
      } else if (!this.idAvls.length) {
        this.$msgBoxOk("Elija al menos un avl");
        return;
      }
      const resp = await axios.post("/execute", {
        method: "CLI.GetVehiculosParaRevisionTecnica",
        parameters: [
          { name: "id_avls", value: this.idAvls },
          { name: "id_instalador", value: this.instalador.id_instaladores },
        ],
      });
      if (resp.data.ok) {
        this.trazabilidad = get(resp, "data.result[0]", []);
        this.testeo = get(resp, "data.result[1]", []);

        this.$store.commit("AccesoTesteo/setTesteos", this.testeo);
        this.$store.commit("AccesoTesteo/setTrazabilidad", this.trazabilidad);
        this.$router.push(`/admin/acceso-testeos/vehiculos`);
        this.cerrarModal();
      } else {
        this.$msgBoxOk(
          get(resp, "data.message", "Error al procesar la solicitud"),
        );
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    async getContratos() {
      if (!this.gridApi) return;

      this.gridApi.showLoadingOverlay();
      const resp = await axios.post("/execute", {
        method: "CLI.GetContratosDeClientes",
        parameters: [],
      });
      if (get(resp, "data.ok", [])) {
        this.rowData = get(resp, "data.result[0]", []);
      }
      setTimeout(() => {
        this.gridApi.hideOverlay();
      }, 0);
    },
  },
  data: () => ({
    testeo: [],
    trazabilidad: [],
    instalador: null,
    rowData: null,
    quickFilter: "",
    seleccionados: [],
    idAvls: "",
    // ag-grid config
    modules: AllModules,

    gridApi: null,
    columnApi: null,

    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },

    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      wrapText: true,
      autoHeight: true,
      minWidth: 120,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },
    columnDefs: [
      {
        headerName: "#Id AVL",
        field: "id_avl",
        checkboxSelection: true,
        showDisabledCheckoboxes: true,
        sort: "asc",
        comparator: (a, b) => {
          const numA = parseInt(a);
          const numB = parseInt(b);
          return numA - numB;
        },
        maxWidth: 130,
      },
      {
        headerName: "IMEI",
        field: "imei",
        minWidth: 160,
      },
      {
        headerName: "Cliente",
        field: "cliente",
        minWidth: 140,
      },
      {
        headerName: "Tipo de Contrato",
        field: "nombre_contrato",
        minWidth: 160,
      },
      {
        headerName: "Patente",
        field: "patente",
      },
      {
        headerName: "Alias",
        field: "dominio",
      },
      {
        headerName: "Marca Modelo",
        cellRenderer: (params) => {
          return `${params.data.marca} ${params.data.modelo}`;
        },
        valueGetter: (params) => {
          return `${params.data.marca} ${params.data.modelo}`;
        },
        minWidth: 150,
      },
      {
        headerName: "Celular",
        field: "numero",
        minWidth: 160,
      },
    ],
  }),
  watch: {
    quickFilter(val) {
      if (this.gridApi) {
        this.gridApi.setQuickFilter(val);
      }
    },
    seleccionados() {
      this.actualizarSeleccionPatentes();
    },
  },
};
</script>

<style scoped>
.badge-custom {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin: 4px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #333;
}

.btn-badge-close {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #fff;
  border: 1px solid #aaa;
  border-radius: 50%;
  color: #555;
  width: 18px;
  height: 18px;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.btn-badge-close:hover {
  background-color: #f0f0f0;
  color: #d00;
  border-color: #d00;
  transform: scale(1.1);
}
</style>
